var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.editor)?_c('div',{staticClass:"m-2 border border-gray-200 bg-white rounded"},[_c('menu-bar',{attrs:{"editor":_vm.editor}}),_c('editor-content',{staticClass:"h-90 overflow-y-auto",attrs:{"editor":_vm.editor}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }